import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Alert, Box, Button, CircularProgress, Container } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { isBursarUser, isLibrarianUser } from "../utils/staffRoles";
import { useHomeroomTeacherTerm } from "../hooks/useHomeroomTeacherTerm";
import { useFormTeacherHomeroom } from "../hooks/useFormTeacherHomeroom";

/**
 * Homeroom routes — teaching staff only; class link required when requireClass is set.
 */
export default function HomeroomTeacherOnly({ children, requireClass = false }) {
    const { currentUser } = useSelector((state) => state.user);
    const homeroomTerm = useHomeroomTeacherTerm();
    const { hasHomeroomClass, loading, refresh } = useFormTeacherHomeroom();

    if (isBursarUser(currentUser) || isLibrarianUser(currentUser)) {
        return <Navigate to="/Teacher/dashboard" replace />;
    }

    if (loading && requireClass) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (requireClass && !hasHomeroomClass) {
        return (
            <Container maxWidth="md" sx={{ py: 3 }}>
                <Alert severity="warning" sx={{ borderRadius: 2 }}>
                    You have the <strong>{homeroomTerm.roleTitleCaps}</strong> role, but no class is linked yet. Ask
                    your director to use <strong>Staff → Assign class</strong> (pick e.g. Form 1 or Std 5), then open{" "}
                    <strong>My class</strong> again.
                </Alert>
                <Button component={RouterLink} to="/Teacher/my-class" sx={{ mt: 2 }} variant="contained">
                    Go to My class
                </Button>
                <Button onClick={() => refresh()} sx={{ mt: 2, ml: 1 }}>
                    Refresh
                </Button>
            </Container>
        );
    }

    return children;
}
